/** Гифки: клиент ходит только в наш API, ключ Klipy живёт на сервере. */
import { useEffect, useState } from 'react'
import { getVersion } from './api'
import { authed } from './auth'

export interface GifImage {
  url: string
  width: number
  height: number
}

export interface Gif {
  id: string
  title: string
  /** Мелкая версия для сетки. */
  preview: GifImage
  /** Та, что уходит в сообщение. */
  full: GifImage
}

export interface GifPage {
  items: Gif[]
  has_next: boolean
}

export interface GifCategory {
  name: string
  query: string
  preview: string
}

/** Адрес нашего прокси к файлу гифки: через него и качаем. */
export const gifFileUrl = (url: string) => `/gifs/file?url=${encodeURIComponent(url)}`

export const gifsApi = {
  trending: (limit = 24) => authed<GifPage>(`/gifs/trending?limit=${limit}`),
  search: (query: string, limit = 24) => authed<GifPage>(`/gifs/search?q=${encodeURIComponent(query)}&limit=${limit}`),
  categories: () => authed<{ categories: GifCategory[] }>('/gifs/categories'),
}

let enabled: boolean | null = null
let asking: Promise<boolean> | null = null

/** Настроен ли поиск гифок. Спрашиваем один раз на всё приложение: ответ не меняется. */
export function useGifsEnabled(): boolean {
  const [on, setOn] = useState(enabled ?? false)
  useEffect(() => {
    if (enabled !== null) return
    asking ??= getVersion()
      .then((v) => (enabled = Boolean(v.gifs)))
      .catch(() => (enabled = false))
    let alive = true
    void asking.then((v) => {
      if (alive) setOn(v)
    })
    return () => {
      alive = false
    }
  }, [])
  return on
}
